@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.voiceassistant

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.voiceassistant.VoiceAssistantSettingsDto
import com.narbase.letsgo.web.models.voiceassistant.VoiceAssistantModelRole

object ListVoiceAssistantProviderModelsEndpoint :
    EndPoint<ListVoiceAssistantProviderModelsEndpoint.Request, ListVoiceAssistantProviderModelsEndpoint.Response>() {
    class Request(
        val settings: VoiceAssistantSettingsDto,
        @Suppress("NON_EXPORTABLE_TYPE") val role: DtoName<VoiceAssistantModelRole>,
        val transcriptionFallbackIndex: Int? = null,
    )

    class Response(
        val models: Array<String>,
        val failure: String?,
    )
}
